export default {
  clientsOptionsRfcList: [],
  clientsList: [],
  tradeName: '',
  name: '',
  rfc: '',
};
